import { Box } from '@mui/material';
import { DataGridPro, DataGridProProps, GridColDef, GridValueGetterParams } from '@mui/x-data-grid-pro';
import React from 'react';

import { RouterLink } from 'app/components/router-link';
import { Store } from 'app/model/cris/store';

interface StoreListGridProps extends Omit<DataGridProProps, 'columns'> {
    rows: Store[];
}

const columns: Array<GridColDef<Store>> = [
    {
        field: 'id',
        headerName: 'ID',
        width: 150,
    },
    {
        field: 'name',
        headerName: 'Name',
        width: 250,
        renderCell: (data) => <RouterLink to={`/cris/stores/${data.row.id}`}>{data.value}</RouterLink>,
    },
    {
        field: 'number',
        headerName: 'Number',
        width: 150,
    },
    {
        field: 'type',
        headerName: 'Type',
        width: 150,
    },
    {
        field: 'oldStores',
        headerName: 'Old Stores',
        width: 150,
        valueGetter: (params: GridValueGetterParams<Store, Store['oldStores']>) => (params.value ?? []).join(', '),
    },
    {
        field: 'locationId',
        headerName: 'Location Id',
        width: 150,
    },
    {
        field: 'isDefault',
        headerName: 'Default',
        width: 120,
        disableColumnMenu: true,
        valueGetter: (params) => (params.value ? 'Yes' : 'No'),
    },
    {
        field: 'domain',
        headerName: 'Domain',
        width: 150,
    },
    {
        field: 'tagSource',
        headerName: 'Tagging Source',
        width: 150,
    },
];

export class StoreListGrid extends React.Component<StoreListGridProps> {
    public render(): React.ReactNode {
        return (
            <Box sx={{ width: '100%', display: 'grid', height: '100%' }}>
                <DataGridPro {...this.props} columns={columns} />
            </Box>
        );
    }
}
